webpackJsonp([63],{

/***/ "4Yp3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-router-modals-container_09455183bd61e7c8325123dbdee000ba.html";

/***/ }),

/***/ "wg/K":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionRouterModalsContainer = (function () {
    function SubscriptionRouterModalsContainer() {
    }
    return SubscriptionRouterModalsContainer;
}());
angular.module('animatronApp.SubscriptionRouterModalsContainer', [])
    .component('subscriptionRouterModalsContainer', {
    controller: SubscriptionRouterModalsContainer,
    templateUrl: __webpack_require__("4Yp3")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/63-bd880478516a225297ea.min.js